import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import InvoiceApp from './InvoiceApp.vue';

export const initInvoice = () => {
  if (!document.getElementById('invoice-app')) {
    return;
  }

  const app = createApp(InvoiceApp);
  app.config.$companyName = window.COMPANY_NAME;

  const routes = [
    {
      path: '/profile/invoice/:page?/:sort?',
      name: 'invoice',
      props: (route) => ({
        page: Number(route.params.page || 1), // Force number casting,
        sort: route.params.sort,
      }),
      component: InvoiceApp,
    },
  ];

  const router = createRouter({
    routes,
    history: createWebHistory(),
  });

  app.use(router);
  app.mount('#invoice-app');
};
